"use client";
import { useState } from "react";

export default function BusinessDetailsStep({ data, setData }) {
    console.log("BusinessDetailsStep data:", data);
    console.log("BusinessDetailsStep setData:", setData);
    const [taxType, setTaxType] = useState("gst");

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(`BusinessDetailsStep ${name}:`, value);
        setData({
            ...data,
            [name]: value,
            ...(taxType === "gst" && { gst_image: STATIC_IMAGES.gst_image }),
            ...(taxType === "nonGst" && { pan_image: STATIC_IMAGES.pan_image }),
            logo: STATIC_IMAGES.logo
        });
    };

    // const handleFileChange = (e) => {
    //     const { name, files } = e.target;
    //     setData({
    //         ...data,
    //         [name]: files[0]
    //     });
    // };

    const STATIC_IMAGES = {
        gst_image: "https://example.com/images/gst.jpg",
        pan_image: "https://example.com/images/pan.jpg",
        logo: "https://example.com/images/logo.jpg"
    };


    return (
        <div className="">
            <h2 className="h4 fw-semibold text-dark mb-0 px-0 py-4">
                Business Information
            </h2>

            <div className="border shadow-sm" style={{ borderRadius: "14px" }}>

                {/* ================= Tax Information ================= */}
                <div className="border-0 mt-4">
                    <div className="card-body p-4 pt-0">

                        <div className="d-flex gap-3 mb-3" style={{ gap: "18px" }}>

                            <div
                                className={`px-2 py-1 border rounded d-flex align-items-center ${taxType === "gst" ? "border-warning bg-light active-card" : "border-secondary"}`}
                                onClick={() => setTaxType("gst")}
                                style={{ cursor: "pointer", width: "120px", gap: "8px" }}
                            >
                                <input type="radio" checked={taxType === "gst"} readOnly />
                                <span>GST</span>
                            </div>

                            <div
                                className={`px-2 py-1 border rounded d-flex align-items-center ${taxType === "nonGst" ? "border-warning bg-light active-card" : "border-secondary"}`}
                                onClick={() => setTaxType("nonGst")}
                                style={{ cursor: "pointer", width: "120px", gap: "8px" }}
                            >
                                <input type="radio" checked={taxType === "nonGst"} readOnly />
                                <span>Non-GST</span>
                            </div>

                        </div>

                        {/* GST */}
                        {taxType === "gst" && (
                            <>
                                <div className="mb-3">
                                    <label className="form-label">
                                        GST Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="gst_number"
                                        value={data.gst_number}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter GST Number"
                                    />
                                </div>

                                <div>
                                    <label className="form-label">
                                        GST Certificate <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="gst_image"
                                        // onChange={handleFileChange}
                                        value="https://example.com/images/gst.jpg"
                                        className="form-control p-0"
                                    />
                                </div>
                            </>
                        )}

                        {/* NON GST */}
                        {taxType === "nonGst" && (
                            <>
                                <div className="mb-3">
                                    <label className="form-label">
                                        PAN Card Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="pan_number"
                                        value={data.pan_number}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter PAN Card Number"
                                    />
                                </div>

                                <div>
                                    <label className="form-label">
                                        Upload PAN Card <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="pan_image"
                                        value="https://example.com/images/gst.jpg"
                                        // onChange={handleFileChange}
                                        className="form-control p-0"
                                    />
                                </div>
                            </>
                        )}

                    </div>

                    <div className="mx-4 my-0 border-bottom mt-2"></div>
                </div>

                {/* ================= Business Details ================= */}
                <div className="border-0">
                    <div className="card-body p-4">

                        <h5 className="mb-3 fw-semibold text-secondary">Business Details</h5>

                        <div className="d-flex" style={{ gap: "20px" }}>
                            <div className="w-50">
                                <label className="form-label">
                                    Business Type <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select p-2 w-100"
                                    name="bussiness_type"
                                    value={data.bussiness_type}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Business Type</option>
                                    <option value="sole_proprietorship">Sole Proprietorship</option>
                                    <option value="partnership">Partnership</option>
                                    <option value="private_limited">Private Limited</option>
                                </select>
                            </div>

                            <div className="w-50">
                                <label className="form-label">
                                    Store Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="store_name"
                                    value={data.store_name}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Your store display name"
                                />
                            </div>
                        </div>

                        <div className="d-flex mt-3" style={{ gap: "20px" }}>
                            <div className="w-50">
                                <label className="form-label">
                                    Company Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="company_name"
                                    placeholder="Company name"
                                    value={data.company_name}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="w-50">
                                <label className="form-label">
                                    Business Logo <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="logo"
                                    placeholder="Business logo"
                                    // onChange={handleFileChange}
                                    value="https://example.com/images/gst.jpg"
                                    className="form-control p-0"
                                />
                            </div>
                        </div>

                        <div className="d-flex mt-3" style={{ gap: "20px" }}>
                            <div className="w-50">
                                <label className="form-label">User Name<span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    name="user_name"
                                    placeholder="User name"
                                    value={data.user_name}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>
                            <div className="w-50"></div>
                        </div>
                    </div>
                </div>

                <div className="mx-4 my-0 border-bottom mt-2"></div>

                {/* ================= Address ================= */}
                <div className="border-0">
                    <div className="card-body p-4">

                        <h5 className="mb-3 fw-semibold text-secondary">Business Address<span className="text-danger">*</span></h5>

                        <div className="d-flex" style={{ gap: "20px" }}>
                            <div className="w-50">
                                <textarea
                                    rows={2}
                                    name="short_description"
                                    value={data.short_description}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="short description of your address"
                                />
                            </div>
                            <div className="w-50">
                                <textarea
                                    rows={2}
                                    placeholder="description of your address"
                                    name="description"
                                    value={data.description}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="row g-3 mt-2">
                            <div className="col-md-6">
                                <label className="form-label">Pincode<span className="text-danger">*</span></label>
                                <input type="text" name="pincode" value={data.pincode} onChange={handleChange} className="form-control" placeholder="Pincode" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">City<span className="text-danger">*</span></label>
                                <input type="text" name="city" value={data.city} onChange={handleChange} className="form-control" placeholder="City" />
                            </div>
                        </div>

                        <div className="row mt-2 g-3">
                            <div className="col-md-6">
                                <label className="form-label">State<span className="text-danger">*</span></label>
                                <input type="text" name="state" value={data.state} onChange={handleChange} className="form-control" placeholder="State" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Country<span className="text-danger">*</span></label>
                                <input type="text" name="country" value={data.country} onChange={handleChange} className="form-control" placeholder="Country" />
                            </div>
                        </div>

                        <div className="row g-3 mt-2">
                            <div className="col-md-6">
                                <label className="form-label">Street<span className="text-danger">*</span></label>
                                <input type="text" name="street" value={data.street} onChange={handleChange} className="form-control" placeholder="Street" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Locality<span className="text-danger">*</span></label>
                                <input type="text" name="locality" value={data.locality} onChange={handleChange} className="form-control" placeholder="Locality" />
                            </div>
                        </div>

                        <div className="row g-3 mt-2">
                            <div className="col-md-6">
                                <label className="form-label">Area Code<span className="text-danger">*</span></label>
                                <input type="text" name="area_code" value={data.area_code} onChange={handleChange} className="form-control" placeholder="Area Code" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">City Code<span className="text-danger">*</span></label>
                                <input type="text" name="city_code" value={data.city_code} onChange={handleChange} className="form-control" placeholder="City Code" />
                            </div>
                        </div>

                        <div className="row g-3 mt-2">
                            <div className="col-md-6">
                                <label className="form-label">Latitude<span className="text-danger">*</span></label>
                                <input type="text" name="latitude" value={data.latitude} onChange={handleChange} className="form-control" placeholder="Latitude" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Longitude<span className="text-danger">*</span></label>
                                <input type="text" name="longitude" value={data.longitude} onChange={handleChange} className="form-control" placeholder="Longitude" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
